import { Box } from "@mui/material";
import {
  accountInfoDataSelector,
  roleMenuDataSelector,
} from "layouts/Sidenav/redux/selector";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ListLeave } from "./components/LeaveApplication";
import { OrderManagement } from "./components/OderManagement";
import { TimeKeeping } from "./components/TimeKeeping";

import {
  ContentTabWrapper,
  DeclareLeaveWrapper,
  TabCustom,
  TabsCustom,
  TabWrapper,
} from "./style";
import { TimeKeepingManagement } from "./components/TimeKeepingManagement";
import MonthlyTimeSheet from "./components/MonthlyTimeKeeping";
import { useEffect } from "react";
import { SCREEN } from "helper/roleChecker/Screens";
import { TimeKeepingHR } from "./components/TimeKeepingHR";
import { getConfigMinDateStart } from "modules/DeclareLeave/redux/getConfigMinDate";
import { ListEmployeeLeave } from "./components/EmployeeLeaveApplication";

export const declareLeaveURL = {
  main: "declare-leave",
  orderLeave: "order-leave",
  orderManagement: "order-management",
  timeKeeping: "time-keeping",
  monthlyTimeKeeping: "monthly-time-keeping",
  timeSheetManagement: "timeSheet-management",
  timeSheetHR: "timeSheet-HR",
  leave: "leave",
  lackOfTime: "lack-of-time",
  feedback: "list-feedback",
  employeeOrderLeave: "employee-order-leave",
  earlyRegistration: "register-early",
};

const DeclareLeaveContent = () => {
  const { tab: content } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { manager } = useSelector(accountInfoDataSelector);
  const { pathname } = useLocation();
  const role = useSelector(roleMenuDataSelector);

  const handleClickNavigate = (tabContent: string) => {
    navigate(`/${declareLeaveURL.main}/${tabContent}`);
  };

  const listTab = [
    {
      key: declareLeaveURL.timeKeeping,
      label: "Ngày công của tôi",
      enable: role?.includes(SCREEN.IP_015),
      component: <TimeKeeping />,
    },
    {
      key: declareLeaveURL.orderLeave,
      label: "Quản lý đơn",
      enable: role?.includes(SCREEN.IP_016),
      component: <ListLeave />,
    },
    {
      key: declareLeaveURL.monthlyTimeKeeping,
      label: "Chấm công tháng",
      enable: role?.includes(SCREEN.IP_018),
      component: <MonthlyTimeSheet />,
    },
    {
      key: declareLeaveURL.orderManagement,
      label: "Quản lý đơn (CBQL)",
      enable: manager && role?.includes(SCREEN.IP_017),
      component: <OrderManagement />,
    },
    {
      key: declareLeaveURL.timeSheetManagement,
      label: "Quản lý chấm công (CBQL)",
      enable: manager && role?.includes(SCREEN.IP_019),
      component: <TimeKeepingManagement />,
    },
    {
      key: declareLeaveURL.timeSheetHR,
      label: "Bảng chấm công (NS)",
      enable: role?.includes(SCREEN.IP_021),
      component: <TimeKeepingHR />,
    },
    {
      key: declareLeaveURL.employeeOrderLeave,
      label: "Quản lý đơn CBNV (HC & NS)",
      enable: role?.includes(SCREEN.IP_023),
      component: <ListEmployeeLeave />,
    },
  ];

  useEffect(() => {
    if (content === declareLeaveURL.orderManagement && manager === false) {
      const path = pathname.replace(
        declareLeaveURL.orderManagement,
        declareLeaveURL.orderLeave
      );
      navigate(path);
    }
  }, [content, manager, navigate, pathname]);

  useEffect(() => {
    dispatch(getConfigMinDateStart());
  }, []);

  return (
    <DeclareLeaveWrapper>
      <ContentTabWrapper sx={{ overflow: "scroll" }}>
        <TabsCustom
          value={content}
          onChange={(_, newValue) => {
            handleClickNavigate(newValue);
          }}
          indicatorColor="secondary"
          textColor="inherit"
          variant={manager ? "scrollable" : "fullWidth"}
        >
          {listTab.map((tab) => {
            if (tab.enable) {
              return (
                <TabWrapper
                  key={tab.key}
                  label={<TabCustom>{tab.label}</TabCustom>}
                  aria-controls={"leave-management"}
                  id={tab.key}
                  value={tab.key}
                />
              );
            }
            return null;
          })}
        </TabsCustom>
        <Box>
          {listTab.map((tab) => {
            if (tab.key === content && tab.enable) {
              return <>{tab.component}</>;
            }
            return null;
          })}
        </Box>
      </ContentTabWrapper>
    </DeclareLeaveWrapper>
  );
};

export default DeclareLeaveContent;
